<!-- eslint-disable -->
<template>
  <div
    class="relative w-full h-[1.125rem] bg-transparent border-[2px] border-b-0 border-blue-500 rounded-t md:min-w-[64ch] mb-5"
  >
    <div
      v-for="(tick, idx) in ticks"
      :key="idx"
      class="absolute w-[2px] -translate-x-1/2 bg-blue-500 top-0 first:bg-transparent last:bg-transparent"
      :style="{
        left: `${tick.position}%`,
        height: shouldHideLabel(idx) ? '0.7rem' : '1.125rem',
      }"
    >
      <span
        v-if="!shouldHideLabel(idx)"
        class="absolute bottom-0 translate-y-full -translate-x-1/2 text-sm font-bold text-gray-600"
      >
        {{ tick.label }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import {computed} from 'vue';
import {
  findLevelIndexByIncrement,
  gradeIncrementLevels,
} from '../../../composables/useGradeIncrementLevels';

const props = defineProps({
  weight: {type: Number, required: true},
  gradeIncrement: {type: Number, required: true},
});

const ticks = computed(() => {
  const gradeIncrementLevel = gradeIncrementLevels[findLevelIndexByIncrement(props.gradeIncrement)];
  const gradeIncrement =
    gradeIncrementLevel.gradeIncrement == 0.333 ? 1 / 3 : gradeIncrementLevel.gradeIncrement;
  const list = [];

  for (let i = 0; i < gradeIncrementLevel.numberOfTicks; i++) {
    const value = i * gradeIncrement * props.weight;
    const position = i * gradeIncrement * 100;
    list.push({value, position, label: formatLabel(value, gradeIncrement)});
  }

  list.push({
    value: props.weight,
    position: 100,
    label: formatLabel(props.weight, gradeIncrement),
  });
  return list;
});

function formatLabel(v: number, inc: number) {
  const decimals = [0.333, 0.125].includes(+inc.toFixed(3)) ? 3 : 2;
  return +v.toFixed(decimals);
}

const shouldHideLabel = (idx: number) => {
  // Hide odd labels only for 0.05 gradeIncrement (precision)
  return props.gradeIncrement === 0.05 && idx % 2 !== 0;
};
</script>
